import { render, staticRenderFns } from "./products-list.vue?vue&type=template&id=0d828465&"
import script from "./products-list.vue.ts?vue&type=script&lang=ts&"
export * from "./products-list.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports